module.exports = __webpack_public_path__ + "img/clients-residenceinn.fa600208.png";